import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            最新爆料
          </h2>
          <span className="text-sm text-foreground-500">共 {cardsData.length} 条热帖</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden h-[200px] flex-shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                />
                <span className={`absolute top-3 left-3 px-2 py-0.5 text-xs font-semibold text-background-50 ${card.tagColor} rounded whitespace-nowrap`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-bold text-foreground-950 font-heading mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{card.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}